import { Component } from '@angular/core';
import { Paginator } from './../../../models/paginator.model';
import { Router } from '@angular/router';
import { Category } from '../../../models/category.model';
import { CategoryService } from '../../../shared/services/category/category.service';
import { DeviceDetectorService } from '../../../shared/services/utils/device-detector.service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../../shared/services/seo.service';

@Component({
  selector: 'app-home-categories',
  imports: [CarouselModule, CommonModule, SharedModule],
  templateUrl: './home-categories.component.html',
  styleUrl: './home-categories.component.scss'
})
export class HomeCategoriesComponent {

  public withControlOptions = {
    loop: true,
    autoplay: false,
    mouseDrag: false,
    dots: false,
    nav: true,
    navSpeed: 700,
    navText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>",
    ],
    responsive: {
      0: {
        items: 3,
      },
    },
  };

  categories: Category[] = [];
  paginator: Paginator;

  constructor(private _categoryService: CategoryService,
    private _deviceDetectorService: DeviceDetectorService,
    private _router: Router, private seo: SeoService) {
    /**
   * Sets up SEO meta tags using SeoService
   * This helps in optimizing the page for search engines and social media previews.
*/
    this.seo.setTags({
      title: 'Home Categories component', // Title
      titleSuffix: '- Shining On Safety', // Title Suffix
      description: 'Shining On Safety', // Description
      image: '', // Image
      keywords: 'Shining On Safety' // Keywords
    });
  }


  ngOnInit(): void {
    this.filter({ value: "", page: 1 });
    if (this._deviceDetectorService.isMobileDevice()) {
      this.withControlOptions.responsive[0].items = 1;
    } else {
      this.withControlOptions.responsive[0].items = 3;
    }
  }

  filter({ value, page }: any) {
    this._categoryService.filter(value, page, 30).subscribe({
      next: (res) => {
        this.categories = res.data;
        this.paginator = res.paginator;
      },
      error: (error) => {
      },
    })
  }

  calculatePage() {
    if (this.paginator.page < 1) {
      this.paginator.page++;
      return;
    }
    this.filter({ value: "", page: this.paginator.page });
  }

  redirectToSearch(value: any) {
    window.scrollTo(0, 0);
    this._router.navigate(["/search"], { queryParams: { category: value } })
  }

}
